module.exports = __webpack_public_path__ + "static/media/american.bf20d5ac.svg";